// extracted by mini-css-extract-plugin
export default {"LanguageMenuLink":"LanguageMenuLink_LanguageMenuLink__N51P1"};